import React from 'react';
import { useDispatch } from 'react-redux';
import { setReleaseNotesVisible } from '../../actions/layout';
import { APP_VERSION, APP_VERSION_D } from '../../config';
import logoImg from '../../static/logo.svg';
import styles from './ReleaseNotes.module.less';
import { cacheKeys } from '../../constants/storageKeys';

const ReleaseNotes = () => {
  const dispatch = useDispatch();
  const startInfoStr = localStorage.getItem(cacheKeys.START_INFO);
  const startInfo = JSON.parse(startInfoStr || '{}');
  return (
    <div className={styles.ReleaseNotes}>
      <span
        className="icon close"
        onClick={() => {
          dispatch(setReleaseNotesVisible(false));
        }}
      >
        <i className="iconfont icon-close" />
      </span>
      <div className="top">
        <img src={logoImg} alt="" className="logo" />
        联想软件商店
      </div>
      <div className="header">
        <div className="title">版本特性与功能</div>
      </div>
      <div className="cont">
        <div className="ver">
          <span className="name">版本：</span>
          <span className="val">{startInfo.isDStore ? APP_VERSION_D : APP_VERSION}</span>
        </div>
        <div className="list">
          <div className="item">
            <span className="num">1.</span>
            <span className="text">消息中心上线了！最新互动消息，通知一键获取。</span>
          </div>
          <div className="item">
            <span className="num">2.</span>
            <span className="text">网页版软件上架，一键打开，便捷使用。</span>
          </div>
          <div className="item">
            <span className="num">3.</span>
            <span className="text">酷软圈入驻软件详情页，浏览相关帖子，一起随心畅聊。</span>
          </div>
          <div className="item">
            <span className="num">4.</span>
            <span className="text">热搜全新改版，为你推荐流行趋势。</span>
          </div>
          <div className="item">
            <span className="num">5.</span>
            <span className="text">商店窗口尺寸支持自由拖动与最大化了，快来试试吧。</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReleaseNotes;
